export default __webpack_public_path__ + "static/media/icon-menu-order.0280056a.svg";